/**
 * @generated SignedSource<<778a2a72577ef949bb8b80a37df9a015>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LikesButton_likeable$data = {
  readonly id: string;
  readonly likedByMe: boolean;
  readonly " $fragmentType": "LikesButton_likeable";
};
export type LikesButton_likeable$key = {
  readonly " $data"?: LikesButton_likeable$data;
  readonly " $fragmentSpreads": FragmentRefs<"LikesButton_likeable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LikesButton_likeable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "likedByMe",
      "storageKey": null
    }
  ],
  "type": "Likeable",
  "abstractKey": "__isLikeable"
};

(node as any).hash = "1602c1fbcb645b46414f2ac2f4e8358d";

export default node;
